import React from 'react';

import UDFormCheckbox from 'ud-form/components/checkbox';
import UDText from 'ud-ui/components/text';
import { TooltipPosition, TooltipProps, TooltipWrapper } from 'ud-ui/components/tippy';

interface UDFormLabeledCheckboxProps extends TooltipProps {
  label: string;
  name: string;
  containerClassName?: string;
  disabled?: boolean;
}

const UDFormLabeledCheckbox: React.FC<UDFormLabeledCheckboxProps> = ({
  label,
  name,
  containerClassName = 'flex items-center mb-4',
  tooltip,
  tooltipProps,
  disabled = false,
}) => {
  const tooltipPosition = tooltipProps?.position || 'right';

  const renderTooltip = (position: TooltipPosition) => (
    <TooltipWrapper tooltip={tooltip} tooltipProps={{ ...tooltipProps, position }} position={position} />
  );

  return (
    <div className={containerClassName}>
      <div className="flex min-h-10 w-full items-center justify-between">
        <div className="mr-2 flex items-center">
          {tooltipPosition === 'left' && renderTooltip('left')}
          <UDText type="callout" className="text-surfaceRaisinBlack50">
            {label}
          </UDText>
          {tooltipPosition === 'right' && renderTooltip('right')}
        </div>
        <div className="flex items-center">
          {tooltipPosition === 'input-left' && renderTooltip('input-left')}
          <UDFormCheckbox name={name} disabled={disabled} />
          {tooltipPosition === 'input-right' && renderTooltip('input-right')}
        </div>
      </div>
    </div>
  );
};

export default UDFormLabeledCheckbox;
